// extracted by mini-css-extract-plugin
export default {"global_content":"global_content___iDlkI","img":"img___qR1ru","caption":"caption___EHGhN","text":"text___pENgA","animation":"animation___bOfTU"};